import React from "react";
import "./header.css";
import { useDispatch, useSelector } from "react-redux";
import { Image } from "primereact/image";
import logo from "../../../assets/images/logo.svg";
import { Link, NavLink } from "react-router-dom";
import { Button } from "primereact/button";
import { useState } from "react";
import Notifications from "../../notifications/Notifications";
import { logout } from "../../../redux/userSlice";
import profilePic from "../../../assets/images/dummyProfilePic.png";
import { Avatar } from "primereact/avatar";
import { capitalizeFirstLetter } from "../../../helpers/utils";

const Header = ({ sidebarHandler }) => {
  const { currentUser } = useSelector((state) => state.user);
  const [menuMobile, setMenuMobile] = useState(false);
  const [notificationPopup, setNotificationPopup] = useState(false);
  const [profilePicture, setProfilePicture] = useState(profilePic);

  const dispatch = useDispatch();
  // const { currentUser } = useSelector((state) => state.user);

  return (
    <header className="layout-topbar">
      <div className="sideBar">
        <Button
          type="button"
          className="p-link layout-menu-button layout-topbar-button"
          onClick={sidebarHandler}
        >
          <i className="pi pi-bars"></i>
        </Button>
      </div>

      <Link className="layout-topbar-logo" to="/">
        <Image src={logo} alt="Logo" />
      </Link>

      <div className="layout-right-wrap">
        <NavLink to="/settings">
          <Button
            style={{
              borderRadius: "20px",
              padding: "0",
              border: "0",
              background: "white",
            }}
            onClick={() => {}}
          >
            <Avatar
              label={currentUser?.name?.charAt(0)?.toUpperCase() || "A"}
              size="xlarge"
              shape="circle"
              style={{ backgroundColor: "#1c9894", color: "#ffffff" }}
            />
          </Button>
        </NavLink>

        <div className="userInfo">
          <strong>{currentUser?.name || "User"}</strong>
          <br></br>
          <role>
            {currentUser?.role === "sub"
              ? capitalizeFirstLetter(currentUser?.role) + " Agency"
              : capitalizeFirstLetter(currentUser?.role)}
          </role>
        </div>
      </div>
    </header>
  );
};
export default Header;
